import React from 'react';
import './Legend.scss';

interface LegendItem {
  label: string;
  type: 'keep' | 'lost';
}

interface LegendProps {
  items: LegendItem[];
  note?: string;
}

export const Legend: React.FC<LegendProps> = ({ items, note }) => (
  <div className="ovp-legend">
    {items.map((item) => (
      <span key={item.label} className="ovp-legend__item">
        <span className={`ovp-legend__swatch ovp-legend__swatch--${item.type}`} />
        {item.label}
      </span>
    ))}
    {note && <span className="ovp-legend__note">{note}</span>}
  </div>
);
